module.exports = __webpack_public_path__ + "static/media/purewatt-5.f4998aa8.jpg";